<template>
  <div>
    <div class="wd-500" style="margin: 15% auto;">
      <div>
        <h1 class="page-title">Admin</h1>
      </div>
      <div>
        <div>
          <div class="grid-margin stretch-card" style="">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <tbody>
                      <tr class="w-50per">
                        <th class="text-center">User ID(email)</th>
                        <td>
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="아이디를 입력하세요."
                              v-model="id"
                              id="uid"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">Password</th>
                        <td>
                          <div class="form-group">
                            <input
                              type="password"
                              class="form-control"
                              placeholder="비밀번호를 입력하세요."
                              v-model="password"
                              id="upw"
                              @keyup.enter="postLogin()"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div>
                    <input v-model="autoLogin" class="fr" type="checkbox" />
                    <span class="fr"> 자동로그인 </span>
                    <input v-model="uidSave" class="fr" type="checkbox" />
                    <span class="fr"> ID 저장 </span>
                  </div>
                </div>
                <div class="text-right mt-2">
                  <button
                    type="submit"
                    class="btn btn-primary"
                    @click="postLogin()"
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "Login",
  props: {
    msg: String
  },
  data: () => ({
    id: "",
    password: "",
    autoLogin: false,
    uidSave: false
  }),

  mounted: function() {
    /// 당근농장 아이디 로그인
    let uid = this.$route.query.uid;
    let type = this.$route.query.type;

    if (uid != null) {
      const params = {
        uid: uid
      };
      this.axios
        .get("/login/system", {
          params: params
        })
        .then(res => {
          localStorage.setItem("authorization", res.data.result.token);
          localStorage.setItem("uid", res.data.result.uid);
          localStorage.setItem("kname", res.data.result.kname);
          localStorage.setItem("ename", res.data.result.ename);

          if (res.data.status === 0) {
            if (this.uidSave === true) {
              localStorage.setItem("uidSave", this.id);
            } else {
              localStorage.removeItem("uidSave");
            }
            if (type == "editor") {
              router.push("/editor");
            } else {
              router.push("/videos");
            }

            /// 자동 로그인 토큰 발급
            if (this.autoLogin === true) {
              this.axios
                .post("/login/autoLogin", params, {
                  headers: {}
                })
                .then(res => {
                  console.log(res);
                  localStorage.setItem("autologin", res.data.result);
                });
            }
          } else {
            alert("로그인에 실패했습니다. " + res.data.result);
          }
        });
    }
  },

  computed: {
    isAutoLogin: function() {
      return localStorage.getItem("autologin") !== null;
    }
  },

  methods: {
    postLogin: function() {
      if (this.id === "") {
        alert("아이디를 입력해주세요.");
        return false;
      }
      if (this.password === "") {
        alert("패스워드를 입력해주세요.");
        return false;
      }

      const params = {
        uid: this.id,
        password: this.password
      };

      this.axios
        .post("/login", params, {
          headers: {}
        })
        .then(res => {
          console.log(res);
          localStorage.setItem("authorization", res.data.result.token);
          localStorage.setItem("uid", res.data.result.uid);
          localStorage.setItem("kname", res.data.result.kname);
          localStorage.setItem("ename", res.data.result.ename);

          if (res.data.status === 0) {
            if (this.uidSave === true) {
              localStorage.setItem("uidSave", this.id);
            } else {
              localStorage.removeItem("uidSave");
            }

            /// 자동 로그인 토큰 발급
            if (this.autoLogin === true) {
              this.axios
                .post("/login/autoLogin", params, {
                  headers: {}
                })
                .then(res => {
                  console.log(res);
                  localStorage.setItem("autologin", res.data.result);
                });
            }
          } else {
            alert("로그인에 실패했습니다. ");
          }

          router.push("/videos");
        })
        .catch(err => {
          alert("로그인에 실패했습니다. ");
        });
    }
  }
};
</script>

<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue